<template>
   
     <v-card
    class="mx-auto mt-12"
    color="white"
  >
            <v-btn
              block
              color="success"
              class="mr-4"
              @click.stop="validate(),disabled=!disabled"
              >
              Activar
            </v-btn>
        <v-card-title class="mx-auto">
         <h5 class="mx-auto">Datos Generales Empresa</h5>
        </v-card-title>

        <v-card-text >
            <v-form
              ref="form"
              lazy-validation
            >
            <v-text-field
                :disabled="disabled"
                v-model="nombretienda"
                :rules="rules"
                label="Nombre tienda"
                required
            ></v-text-field>
            <v-text-field
             :disabled="disabled"
                v-model="ruc"
                :rules="rules"
                label="Ruc Tienda"
                required
            ></v-text-field>
                <v-row>
                <v-col cols="6" xs="6">
                        <v-text-field
                        :disabled="disabled"
                        v-model="whatsapp"
                        :rules="rules"
                        label="WhatsApp"
                        required
                    ></v-text-field>
                </v-col>
                <v-col cols="6" xs="6">
                         <v-text-field
                        :disabled="disabled"
                        v-model="telefono"
                        :rules="rules"
                        label="Celular/Telefono"
                        required
                    ></v-text-field>
                </v-col>
                </v-row>
             <v-text-field
             :disabled="disabled"
                v-model="direcciontienda"
                :rules="rules"
                label="Direccion fisica"
                required
            ></v-text-field>

            <v-text-field
             :disabled="disabled"
                v-model="direccionfacebook"
                :rules="rules"
                label="Direccion Facebook"
                required
            ></v-text-field>
            <v-text-field
             :disabled="disabled"
                v-model="direccionInstamgra"
                :rules="rules"
                label="Direccion Instagram"
                required
            ></v-text-field>
              <v-text-field
             :disabled="disabled"
                v-model="video"
                :rules="rules"
                label="Link video (iframe)"
                required
            ></v-text-field>


                <v-row>
                <v-col cols="6" xs="6">
            <v-file-input
                :disabled="disabled"
                label="Foto Cabecera"
                filled
                v-model="selectedFile"
                prepend-icon="mdi-camera"
              ></v-file-input>
                </v-col>
                <v-col cols="6" xs="6">
              <v-file-input
                :disabled="disabled"
                label="Logo General"
                filled
                v-model="selectedFile1"
                prepend-icon="mdi-camera"
              ></v-file-input>
                </v-col>
                </v-row>
                
                <v-row>
                <v-col cols="6" xs="6">
                   <v-file-input
                :disabled="disabled"
                label="Logo barrasuperior"
                filled
                v-model="selectedFile2"
                prepend-icon="mdi-camera"
              ></v-file-input>
                </v-col>
                </v-row>

            </v-form>
              
        </v-card-text>
        
        <v-card-actions>
            <v-btn
             :disabled="disabled"
              block
              color="success"
              class="mr-4"
              @click.stop="grabar(),validate(),disabled=!disabled"
              >
              Grabar
            </v-btn>
        </v-card-actions>
                 <v-dialog
            v-model="progress"
            max-width="200"
            >
            <v-card>
                 <v-progress-circular
                  :rotate="90"
                  :size="200"
                  :width="15"
                  :value="Uploadvalue"
                  color="red"
                >
                  {{ Uploadvalue }}
                </v-progress-circular>
            </v-card>

         </v-dialog>
  </v-card>
  

</template>

<script>
// @ is an alias to /src
import { db } from '../db'
import firebase from 'firebase'
import paletaColores from '@/components/paletaColores'

export default {
  name: 'datosgeneralesempresa',

      firebase: {
        tienda: db.database().ref("tienda"),
      },
  components: {
    paletaColores,
  },
    mounted(){
        this.validate() 
    },

  data(){
    return{
        foto:'',
        progress: false,
        selectedFile:0,
        selectedFile1:0,
        selectedFile2:0,
        Uploadvalue:0,
        valid:true,
        picture:null,
        disabled:true,
        nombretienda:'',
        fotocabecera:'',
        fotologo:'',
        ruc:'',
        whatsapp:'',
        telefono:'',
        direcciontienda:'',
        direccionfacebook:'',
        direccionInstamgra:'',
        tienda:'',
        video:'',

        rules: {
            required: value => !!value || 'Required.',
            min: v => v.length >= 8 || 'Min 8 characters',
            emailMatch: () => ('The email and password you entered don\'t match'),
        },
    }
  },

  methods: {
    grabar(){
        if(this.selectedFile){
              this.onupload()
        }
        if(this.selectedFile1){
              this.onuploadLogo()
        }
        if(this.selectedFile2){
              this.onuploadLogo1()
        }

        db.database().ref("tienda").child('nombretienda').set(this.nombretienda)
        db.database().ref("tienda").child('ruc').set(this.ruc)
        db.database().ref("tienda").child('whatsapp').set(this.whatsapp)
        db.database().ref("tienda").child('telefono').set(this.telefono)
        db.database().ref("tienda").child('direcciontienda').set(this.direcciontienda)
        db.database().ref("tienda").child('direccionfacebook').set(this.direccionfacebook)
        db.database().ref("tienda").child('direccionInstamgra').set(this.direccionInstamgra)
        db.database().ref("tienda").child('video').set(this.video)

             this.disabled=false
    },
    validate(){
            this.nombretienda=this.tienda.nombretienda, 
            this.ruc=this.tienda.ruc,
            this.whatsapp=this.tienda.whatsapp,
            this.telefono=this.tienda.telefono,
            this.direcciontienda=this.tienda.direcciontienda,
            this.direccionfacebook=this.tienda.direccionfacebook,
            this.direccionInstamgra=this.tienda.direccionInstamgra,
            this.video=this.tienda.video
        },
        
        onupload(){
            this.progress = true
            console.log("no existe")
         const storageRef = db.storage().ref(`/imagenesDiseño/cabecera`)
         const task=storageRef.put(this.selectedFile)
         task.on('state_changed',snapshot=>{
      
           let porcentaje = (snapshot.bytesTransferred/snapshot.totalBytes)*100
           this.Uploadvalue = porcentaje
         },error=>{console.log(error.message)},
         ()=>{this.Uploadvalue=100;
              task.snapshot.ref.getDownloadURL().then((url)=>{
                this.picture = url;

                db.database().ref("tienda").child("fotocabecera").set(
                       this.picture
                    );
          
 
                this.progress = false
                console.log(this.picture)
              })
         }
         )
        },
        onuploadLogo(){
            this.progress = true
            console.log("no existe")
         const storageRef = db.storage().ref(`/imagenesDiseño/logo`)
         const task=storageRef.put(this.selectedFile1)
         task.on('state_changed',snapshot=>{
      
           let porcentaje = (snapshot.bytesTransferred/snapshot.totalBytes)*100
           this.Uploadvalue = porcentaje
         },error=>{console.log(error.message)},
         ()=>{this.Uploadvalue=100;
              task.snapshot.ref.getDownloadURL().then((url)=>{
                this.picture = url;

                db.database().ref("tienda").child("fotologo").set(
                      url
                    );
          

                this.progress = false
                console.log(this.picture)
              })
         }
         )
        },
        onuploadLogo1(){
                      this.progress = true
            console.log("no existe")
         const storageRef = db.storage().ref(`/imagenesDiseño/logobarrasuperior`)
         const task=storageRef.put(this.selectedFile2)
         task.on('state_changed',snapshot=>{
      
           let porcentaje = (snapshot.bytesTransferred/snapshot.totalBytes)*100
           this.Uploadvalue = porcentaje
         },error=>{console.log(error.message)},
         ()=>{this.Uploadvalue=100;
              task.snapshot.ref.getDownloadURL().then((url)=>{
                this.picture = url;

                db.database().ref("tienda").child("fotologobarrasuperior").set(
                      url
                    );
          

                this.progress = false
                console.log(this.picture)
              })
         }
         )
        }

    },
}
</script>
